<template>
  <div
    class="banner"
    :style="{
      display: extraItem.extras('banner.display') == 1 ? 'block' : 'none',
    }"
  >
    <img :src="extraItem.extras('banner.src')" alt="" />
  </div>
</template>
<script>
export default {
  name: "Banner",
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
